<header class="e11-bg-skin-primary">
  <div class="app-header-logo">
    <h3 class="e11-text-white">logo</h3>
  </div>
  <div class="app-header-content"></div>
</header>
